import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VSnackbar,{attrs:{"timeout":_vm.timeout,"color":_vm.color},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('span',{staticClass:"d-flex align-center justify-center",class:{
            'secondary--text': _vm.useDarkColor,
            'orange--text': _vm.isWarning
        },domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }